import React, { StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";

import ErrorBoundary from "components/ErrorBoundary";
import CustomLocalizationProvider from "CustomLocalizationProvider";
import { ChunkReloadStatus, STORAGE_CHUNK_RELOAD_FLAG } from "globalConstants/storage";
import { triggerChunkReload } from "utils/chunkReload";

import { App } from "./App";
import LoadingScreen from "./components/shared/LoadingScreen";

import "react-toastify/dist/ReactToastify.css";

window.addEventListener("vite:preloadError", event => {
  const flag = sessionStorage.getItem(STORAGE_CHUNK_RELOAD_FLAG);
  if (flag !== ChunkReloadStatus.DONE && flag !== ChunkReloadStatus.PENDING) {
    event.preventDefault();
    triggerChunkReload();
  }
});

const rootElement = document.getElementById("root");

const root = createRoot(rootElement!);

if (sessionStorage.getItem(STORAGE_CHUNK_RELOAD_FLAG) === ChunkReloadStatus.PENDING) {
  sessionStorage.setItem(STORAGE_CHUNK_RELOAD_FLAG, ChunkReloadStatus.DONE);
}

root.render(
  <StrictMode>
    <Suspense fallback={<LoadingScreen />}>
      <HelmetProvider>
        <ErrorBoundary>
          <CustomLocalizationProvider>
            <App />
          </CustomLocalizationProvider>
        </ErrorBoundary>
      </HelmetProvider>
    </Suspense>
  </StrictMode>,
);
